const initState = {
    entities: [
        {id:"1", firstname:"Martin", lastname:"Crowe", gender:"M", createdbyuser:""},
        {id:"2", firstname:"Jeff", lastname:"Crowe", gender:"M", createdbyuser:""},
        {id:"3", firstname:"Ann", lastname:"Crowe", gender:"F", createdbyuser:""},
        {id:"4", firstname:"Whitney", lastname:"Crowe", gender:"F", createdbyuser:""},
        {id:"5", firstname:"Susan", lastname:"Crowe", gender:"F", createdbyuser:""},
    ]
}

const entityReducer = (state = initState, action) => {
    switch (action.type) {
        case 'CREATE_ENTITY':
            console.log('Created Entity', action.entity)
            return state;
        case 'CREATE_ENTITY_ERROR':
            console.log('Created Entity Error', action.err)
            return state;
        case 'UPDATE_ENTITY':
            console.log('Updated Entity', action.entity)
            return state;
        case 'UPDATE_ENTITY_ERROR':
            console.log('Update Entity Error', action.err)
            return state;
        case 'DELETE_ENTITY':
            console.log('Deleted Entity', action.entity)
            return state;
        case 'DELETE_ENTITY_ERROR':
            console.log('Deleted Entity Error', action.err)
            return state;
        case 'CREATE_WELLNESSREPORT':
            console.log('Created Wellness Report', action.entity)
            return state;
        case 'CREATE_WELLNESSREPORT_ERROR':
            console.log('Created Wellness Report Error', action.err)
            return state;
            default:
            return state;
    }
}

export default entityReducer